// extracted by mini-css-extract-plugin
export default {"BidBatchEdit":"bidBatchEdit_BidBatchEdit__67s5R"};